import AccountIcon from '@mui/icons-material/AccountTreeRounded';
import PlayIcon from '@mui/icons-material/PlayArrowRounded';
import SearchIcon from '@mui/icons-material/Search';
import StopIcon from '@mui/icons-material/StopRounded';
import { CircularProgress, IconButton } from '@mui/material';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';
import { v4 as uuidV4 } from 'uuid';
import useLiveContext from '../../LiveContext/useLiveContext';
import StyledToolBar from './styles';
import ContextSelector from '../MainWindow/Components/ContextSelector';

function SessionIcon() {
  const {
    sessionState: { session, sessionLoading },
  } = useLiveContext();

  if (sessionLoading) return <CircularProgress size={42} />;
  if (session) return <StopIcon />;
  return <PlayIcon />;
}

export default function PluginToolbar() {
  const {
    projectId, sessionState, decisionTreeState: { isMounted, setIsMounted },
  } = useLiveContext();
  const location = useLocation();

  const {
    audioConfig: { deviceId }, search, setSearch, sessionState: { session },
  } = useLiveContext();
  return (
    <StyledToolBar className={clsx({ reduced: !!session })}>
      <IconButton
        onClick={() => { if (search === null) { setSearch(''); } else { setSearch(null); } }}
        className={clsx('standard', { active: search !== null })}
      >
        <SearchIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          if (session) sessionState.stopSession();
          else sessionState.startSession({ id: uuidV4(), projectId: projectId ?? '' });
        }}
        className={clsx('session', { active: !!session })}
        disabled={!deviceId || !projectId}
      >
        <SessionIcon />
      </IconButton>
      <IconButton
        className={clsx('standard', { active: isMounted || location.pathname === '/decision-trees' })}
        onClick={() => {
          if (isMounted) {
            setIsMounted(false);
          } else {
            setIsMounted(true);
          }
        }}
      >
        <AccountIcon />
      </IconButton>
      <ContextSelector />
    </StyledToolBar>
  );
}
